import {
    putServiceLoading,
    putServiceRequest,
    putServiceSuccess,
    putServiceReject,
    putServiceReset
} from "../../actions/services/put";

export const putService = (formData, id) => async (dispatch, getState) => {
    dispatch(putServiceLoading());
    try {
        const { data } = await putServiceRequest(formData, getState, id);
        dispatch(putServiceSuccess(data))
    } catch (error) {
        dispatch(putServiceReject(error))
    } finally {
        setTimeout(() => { dispatch(putServiceReset()) }, 3000);
    }
    return Promise.resolve();
};